import { style, styleVariants } from '@vanilla-extract/css';
import { recipe } from '@vanilla-extract/recipes';
import { vars } from '../../theme';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type AvatarShape = 'circle' | 'square';

export const sizePx: Record<AvatarSize, number> = {
  xs: 20,
  sm: 28,
  md: 36,
  lg: 48,
  xl: 64,
};

export const root = recipe({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
    fontFamily: vars.typography.fontFamily.primary,
    fontWeight: vars.typography.fontWeight.semibold,
    color: vars.typography.textColor.primary,
    lineHeight: String(1),
    userSelect: 'none',
    border: `1px solid ${vars.surface.border.subtle}`,
  },
  variants: {
    shape: {
      circle: { borderRadius: vars.spacing.borderRadius.full },
      square: { borderRadius: vars.spacing.borderRadius.md },
    },
  },
  defaultVariants: {
    shape: 'circle',
  },
});

// font sizing for initials, keyed by named size
export const initialsSize = styleVariants({
  xs: { fontSize: vars.typography.fontSize['3xs'] },
  sm: { fontSize: vars.typography.fontSize['2xs'] },
  md: { fontSize: vars.typography.fontSize.xs },
  lg: { fontSize: vars.typography.fontSize.sm },
  xl: { fontSize: vars.typography.fontSize.lg },
});

export const image = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});
